module.exports = __webpack_public_path__ + "static/media/IMG_1390.38cf614e.JPG";